// @flow
import * as React from 'react';
import locale from '../../../../../../locales/index';
import style from './style';

interface Props {
 image: string,
 name: string,
 gender: string,
 residence: string,
 groups: string,
 onClick: Function,
}

const UserRow = (context: Props): React.Element<any> => (
  <tr style={style.rowStyle} onClick={context.onClick}>
    <td style={style.imageRow}><img style={style.imageStyle} src={context.image} alt="" /></td>
    <td style={style.textStyle}>{context.name}</td>
    <td style={style.textStyle}>{locale[context.gender]}</td>
    <td style={style.textStyle}>{context.residence}</td>
    <td style={style.textStyle}>{context.groups}</td>
  </tr>
);

export default UserRow;



// WEBPACK FOOTER //
// ./src/scenes/Users/components/UserList/components/UserRow/UserRow.js